import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { memo, useEffect } from 'react';

import useLocalStorageState from 'hooks/useLocalStorageState';
import useMediaQuery from 'hooks/useMediaQuery';
import useScrollControl from 'hooks/useScrollControl';

import LOCAL_STORAGE from 'constants/localStorage';

const DownloadAppAlertDialog = dynamic(
  () => import('./DownloadAppAlertDialog'),
  {
    ssr: false,
  }
);

const DISABLED_PATHS = ['/cupons'];

const DynamicallyLoadedDownloadAppAlertDialog = () => {
  const { pathname } = useRouter();
  const { isMd } = useMediaQuery();
  const { showScrollable } = useScrollControl();
  const [isDialogActive, setDialogActive] = useLocalStorageState(
    LOCAL_STORAGE.IS_DOWNLOAD_APP_DIALOG_ACTIVE,
    true
  );

  const isDisabledPage = DISABLED_PATHS.some(
    (p) => pathname === p || pathname.startsWith(`${p}/`)
  );

  useEffect(() => {
    if (isMd || !isDialogActive || isDisabledPage) {
      return;
    }

    showScrollable(
      DownloadAppAlertDialog,
      {
        setDialogActive,
      },
      { persist: true }
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
    // showScrollable and setDialogActive return stable refs —
    // intentionally omitted to avoid re-triggering the effect.
  }, [isMd, isDialogActive, isDisabledPage]);

  return null;
};
export default memo(DynamicallyLoadedDownloadAppAlertDialog);
